var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createBrowserHistory } from 'history';
import { isNotNil } from '@unitarius/xbpm-runtime/lib/services/utils/_.utils';
import { toPairs } from 'ramda';
var defaultConfig = {
    home: '/',
};
var XbpmWebNavService = /** @class */ (function () {
    function XbpmWebNavService(history, config) {
        this.history = history || createBrowserHistory({});
        this.config = __assign(__assign({}, defaultConfig), (config || {}));
    }
    XbpmWebNavService.prototype.mapPath = function (navParams) {
        switch (navParams.$kind) {
            case 'task': {
                var processInstanceId = navParams.processInstanceId, taskDefinitionKey = navParams.taskDefinitionKey, modalFormCode = navParams.modalFormCode, force = navParams.force;
                var path = ['', 'processes', processInstanceId, 'forms', taskDefinitionKey, modalFormCode]
                    .filter(isNotNil)
                    .join('/');
                // const extra = initiatorCode ? `?initiator=${initiatorCode}` : '';
                var extra = force ? '?force=true' : '';
                return path + extra;
            }
            case 'process': {
                var processDefinitionKey = navParams.processDefinitionKey, force = navParams.force, etc = __rest(navParams, ["processDefinitionKey", "force"]);
                var extraForce = force ? '?force=true' : '';
                var extraPairs = toPairs(__assign({}, (etc || {})))
                    .map(function (_a) {
                    var k = _a[0], v = _a[1];
                    return k + "=" + v;
                })
                    .join('&');
                var extra = extraForce && extraPairs ? extraForce + '&' + extraPairs : extraPairs ? '?' + extraPairs : extraForce;
                console.log('NAV_SERVICE_MAP_PATH_EXTRA', extra);
                return ['', 'processes', 'key', processDefinitionKey].join('/') + extra;
            }
            case 'application': {
                var applicationGroup = navParams.applicationGroup, applicationCode = navParams.applicationCode, applicationVersion = navParams.applicationVersion, force = navParams.force;
                var extra = force ? '?force=true' : '';
                return (['', 'processes', 'application', applicationGroup, applicationCode, applicationVersion].join('/') + extra);
            }
            case 'free': {
                var _a = navParams, applicationGroup = _a.applicationGroup, applicationCode = _a.applicationCode, applicationVersion = _a.applicationVersion, freeFormCode = _a.freeFormCode, force = _a.force, queryParams = _a.queryParams;
                var query = queryParams &&
                    "" + Object.entries(queryParams)
                        .map(function (pair) { return pair[0] + "=" + pair[1]; })
                        .join('&');
                var extra = force ? '?force=true' : '';
                return (['', 'applications', applicationGroup, applicationCode, applicationVersion, 'forms', freeFormCode].join('/') +
                    extra +
                    (query ? "" + (force ? '&' : '?') + query : ''));
            }
            case 'act': {
                var applicationGroup = navParams.applicationGroup, applicationCode = navParams.applicationCode, applicationVersion = navParams.applicationVersion, action = navParams.action, params = navParams.actionParams;
                var extra = params ? "?actionParams=" + JSON.stringify(params) : '';
                return (['', 'applications', applicationGroup, applicationCode, applicationVersion, 'actions', action].join('/') +
                    extra);
            }
            default:
                return null;
        }
    };
    XbpmWebNavService.prototype.next = function (path, replace) {
        if (replace === void 0) { replace = false; }
        var navigate = replace ? this.history.replace : this.history.push;
        navigate(path);
    };
    XbpmWebNavService.prototype.back = function () {
        this.history.goBack();
    };
    XbpmWebNavService.prototype.navigate = function (params, replace) {
        if (replace === void 0) { replace = false; }
        var path = this.mapPath(params);
        if (path) {
            this.next(path, replace);
        }
    };
    XbpmWebNavService.prototype.home = function (replace) {
        if (replace === void 0) { replace = false; }
        this.next(this.config.home, replace);
    };
    return XbpmWebNavService;
}());
export { XbpmWebNavService };
//# sourceMappingURL=nav.service.js.map